/**
 * 小売開栓結果登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 受付情報
 */
export interface Sgkb121aReqAceptInfoDto {
    /** 
     * 受付番号：半角数字
     */
    aceptNo?: string;
    /** 
     * 受付履歴番号：半角数字
     */
    aceptRrkno?: string;
    /** 
     * 更新通番号：半角数字
     */
    updateSrno?: string;
    /**
     * 契約者情報変更有無フラグ：半角英数混在
     */
    ctrperinfoChangeyesnoFlg?: string;
    /**
     * 変更後　契約者お客さま漢字氏名：全角文字
     */
    afCtrperKnjnm?: string;
    /**
     * 変更後　契約者お客さまカナ氏名：全角カナ
     */
    afCtrperKananame?: string;
    /**
     * 変更後　契約者お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    afCtrperTel1?: string;
    /**
     * 変更後　契約者お客さま電話番号コード１：半角英数混在
     */
    afCtrperTeldivision1?: string;
    /**
     * 変更後　契約者お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    afCtrperTel2?: string;
    /**
     * 変更後　契約者お客さま電話番号コード２：半角英数混在
     */
    afCtrperTeldivision2?: string;
    /**
     * 変更後　契約者お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    afCtrperTel3?: string;
    /**
     * 変更後　契約者お客さま電話番号コード３：半角英数混在
     */
    afCtrperTeldivision3?: string;
    /**
     * 変更後　使用需要者区分：半角英数混在
     */
    afUsingjyuyoshaDiv?: string;
    /**
     * 変更後　使用者お客さま漢字氏名：全角文字
     */
    afUsrvstKnjnm?: string;
    /**
     * 変更後　使用者お客さまカナ氏名：全角カナ
     */
    afUsrvstKananame?: string;
    /**
     * 変更後　使用者お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    afUsrvstTel1?: string;
    /**
     * 変更後　使用者お客さま電話番号コード１：半角英数混在
     */
    afUsrvstTeldivision1?: string;
    /**
     * 変更後　使用者お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    afUsrvstTel2?: string;
    /**
     * 変更後　使用者お客さま電話番号コード２：半角英数混在
     */
    afUsrvstTeldivision2?: string;
    /**
     * 変更後　使用者お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    afUsrvstTel3?: string;
    /**
     * 変更後　使用者お客さま電話番号コード３：半角英数混在
     */
    afUsrvstTeldivision3?: string;
    /** 
     * 公団床暖の申込書受領フラグ：半角数字
     */
    publiccorporationfloorheatingSrndocReceiptflag?: string;
    /** 
     * ガス供給地点特定番号：半角数字
     */
    gasSuppntSpno?: string;
    /** 
     * 開栓作業担当社員番号：半角英数混在
     */
    turnonWorkchargeStafno?: string;
    /** 
     * 手続き完了おしらせ直送可否フラグ：半角英数混在
     */
    procedurecompletionNoticeDeliverypossibility?: string;
    /** 
     * 契約手続き完了通知紙希望フラグ：半角英数混在
     */
    ctrProcedurecompletionPaperhopeflag?: string;
    /** 
     * 料金プラン要確認フラグ：半角英数混在
     */
    priceplanNeedconfirmflag?: string;
    /** 
     * 引継ぎメモ：全角半角混在
     */
    vstinfMemo?: string;
    /** 
     * 要確認対象対応フラグ：半角英数混在
     */
    needconfirmflagResponseFlg?: string;
}